import React, { useState, useEffect, useContext } from "react"
import { 
    GET_FORM,
    SUBMIT_FORM
} from '../graphql/queries'
import { useLazyQuery, useMutation } from '@apollo/client'

import { MainContext } from "../context/context"

import FormTab from "components/formTab"
import { cloneDeep } from 'lodash'

export default ({ 
    id,
    fields,
    submissionTitle,
    whitepaper,
    jobtitle,
}) => {
    const {
		openModal,
    } = useContext(MainContext)

    const [activeTab, setActiveTab] = useState(0)
    const [fieldValues, setFieldValues] = useState({})
    const [hasMountedWithDelay, setHasMountedWithDelay] = useState(false)

    const [getForm, { 
        data: formData,
        error,
        loading
    }] = useLazyQuery(GET_FORM)

    const [submitForm] = useMutation(SUBMIT_FORM)

    const hasFormData = !!formData

    useEffect(() => {
        if(hasFormData || fields){
            setTimeout(() => {
                setHasMountedWithDelay(true)
            }, 100)
        }
    }, [hasFormData])

    useEffect(() => {
        if(id){
            getForm({
                variables: {
                    id
                },
            })
        }
    }, [getForm])

    const getSections = () => {
        if(fields){
            return fields
        }

        return formData ? formData.form.formFields.sections : []
    }

    const handleSubmit = () => {
        const _sections = getSections()
        let _fieldValues = {}
        
        Object.keys(fieldValues).forEach(key => {
            let value = fieldValues[key]

            if(value.value){
                value = value.value
            }

            _fieldValues[key] = value
        })

        let contactDetailsKey = null

        _sections.forEach(section => {
            section.rows.forEach(row => {
                row.columns.forEach(column => {
                    const { type, label } = column

                    if(type === 'recipientSelector'){
                        contactDetailsKey = label
                    }
                })

            })
        })

        const recipients = _fieldValues[contactDetailsKey]

        _fieldValues = JSON.stringify(_fieldValues)

        submitForm({
            variables: {
                data: _fieldValues,
                type: submissionTitle || formData.form.formFields.submissionTitle,
                jobtitle: jobtitle || null,
                recipients
            },
        })

        setTimeout(() => {
            setFieldValues({})
            
            openModal({
                type: 'CONFIRMATION',
                subType: `SCOPE`,
                whitepaper: whitepaper ? whitepaper : ''
            })
        },200)
    }

    const sections = getSections()

    const activeSection = (formData || fields) ? sections[activeTab] : null

    const handleChange = (inputKey, value) => {
        const _fieldValues = cloneDeep(fieldValues)
        
        _fieldValues[inputKey] = value

        setFieldValues(_fieldValues)
    }

    const scrollToTop = () => {
        if(typeof window !== 'undefined'){
            window.scroll({
                top: 150,
                behavior: 'smooth'
            })
        }
    }

    const isLastSlide = (activeTab + 1) === sections.length

    const handleNext = e => {
        e.preventDefault()

        if(!isLastSlide){
            setActiveTab(activeTab + 1)
        }else{
            handleSubmit()
        }

        scrollToTop()

    }

    const handleBack = e => {
        e.preventDefault()

        setActiveTab(activeTab - 1)
        scrollToTop()
    }

    return (
        <>
            { activeSection ?
                <form className={`form-container ${ hasMountedWithDelay ? 'mounted' : ''}`} onSubmit={e => {
                    e.preventDefault()
                    handleSubmit()
                }}>
                    { (sections && sections.length > 1) ? 
                        <ul className="progress-tabs">
                            {sections.map((section, index) => {
                                let className = ''
                                if(index == activeTab) {
                                    className = 'active'
                                }
                                if(index < activeTab) {
                                    className = 'completed'
                                }
                                return (
                                    <li 
                                        className={className} 
                                        key={index}
                                    >
                                        <h4>
                                            {index+1+'. '+section.title}
                                        </h4>
                                    </li>
                                )
                            })}
                        </ul>
                    : null }
                    <div className="form-tabs">
                        <div className={"tab"}>
                            <FormTab 
                                section={activeSection} 
                                handleChange={handleChange}
                                values={fieldValues}
                                isLastSlide={isLastSlide}
                                isFirstSlide={!activeTab}
                                handleNext={handleNext}
                                handleBack={handleBack}
                                showRequiredAsterisk={!!fields}
                            />
                        </div>
                    </div>
                </form>
            : null 
            }
        </>
    )
}